import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export interface RevealedQuotePhone {
  /** 본인인증 전 회원·탈퇴로 파기된 경우 null. */
  readonly phone: string | null;
}

export interface UseRevealQuotePhoneResult {
  /** 복호화한 휴대폰 — 호출부가 컴포넌트 state 에만 둔다. 거절이면 undefined. */
  readonly reveal: (quoteRequestId: string) => Promise<RevealedQuotePhone | undefined>;
  readonly isPending: boolean;
  readonly error: string | null;
  readonly reset: () => void;
}

/**
 * 휴대폰 보기(quoteManagement.revealPhone, 견적 설계 §6-2) — 서버가 복호화하고 감사 로그를 남긴다.
 * useMutation 을 쓰지 않고 useUtils().client 로 바로 부른다 — 복호화 값이 TanStack 뮤테이션 캐시에도
 * 남지 않게 하기 위해서다. 목록·상세 캐시에는 쓰지 않는다.
 */
export const useRevealQuotePhone = (): UseRevealQuotePhoneResult => {
  const utils = trpc.useUtils();
  const action = useAsyncAction(
    (quoteRequestId: string): Promise<RevealedQuotePhone> =>
      utils.client.quoteManagement.revealPhone.mutate({ quoteRequestId }),
    () => undefined,
  );

  return {
    reveal: (quoteRequestId) => action.execute(quoteRequestId),
    isPending: action.isPending,
    error: action.error,
    reset: action.reset,
  };
};
